export default {
  notice: [],
  faq: [],
  ask: [],
};
